import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CarrierFrame } from '@/features/carriers/detail/frame';

// S11–S15: the carrier's header and tabs around the tab's own route.
export const Route = createFileRoute('/_app/carriers/$code')({
  component: CarrierLayout,
});

function CarrierLayout() {
  const { code } = Route.useParams();
  return (
    <CarrierFrame code={code.toUpperCase()}>
      <Outlet />
    </CarrierFrame>
  );
}
